import type { RouteRecordRaw } from 'vue-router'

type ModuleRouteFile = { default: RouteRecordRaw[] }

/**
 * Rutas integradas (built-in) que existen siempre, independientemente de los módulos.
 * Cada módulo puede aportar sus propias rutas vía src/modules/<mod>/routes.ts.
 *
 * Nota: los componentes de login/forbidden/home son responsabilidad de otros agentes;
 * aquí solo declaramos las rutas y referenciamos las vistas esperadas.
 */
const builtinRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/modules/auth/views/LoginView.vue'),
    meta: { layout: 'public' },
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    component: () => import('@/components/feedback/ForbiddenView.vue'),
    meta: { layout: 'public' },
  },
  // La raíz '/' (sitio público) la define el módulo `site`.
]

/**
 * Carga rutas de cada módulo: src/modules/<mod>/routes.ts → default export RouteRecordRaw[]
 */
export function loadModuleRoutes(): RouteRecordRaw[] {
  const files = import.meta.glob('@/modules/*/routes.ts', { eager: true }) as Record<
    string,
    ModuleRouteFile
  >

  const moduleRoutes: RouteRecordRaw[] = []
  for (const mod of Object.values(files)) {
    if (Array.isArray(mod.default)) {
      moduleRoutes.push(...mod.default)
    }
  }

  return [
    ...builtinRoutes,
    ...moduleRoutes,
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ]
}
